import { Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';
import { Stack } from 'commons/components';

interface ShippingMethodCheckboxItemProps {
  code: string;
  displayName: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  disabledMessage?: string;
}

function ShippingMethodCheckboxItem({
  code,
  displayName,
  checked,
  onChange,
  disabled = false,
  disabledMessage,
}: Readonly<ShippingMethodCheckboxItemProps>): JSX.Element {
  const handleChange = () => {
    if (!disabled) {
      onChange();
    }
  };

  return (
    <InteractiveList.CheckboxItem
      title={displayName}
      showTitle={false}
      checkbox={{
        name: code,
        checked,
        onChange: handleChange,
        disabled,
      }}
    >
      <Stack column spacing="tight" align="flex-start">
        <Text
          fontSize="base"
          color={disabled ? 'neutral-textDisabled' : 'neutral-textHigh'}
        >
          {displayName}
        </Text>
        {disabled && !!disabledMessage && (
          <Text fontSize="caption" color="danger-textHigh">
            {disabledMessage}
          </Text>
        )}
      </Stack>
    </InteractiveList.CheckboxItem>
  );
}

export default ShippingMethodCheckboxItem;
